export const state = () => ({
  results: []
});

export const mutations = {
  setResults (state, results) {
    state.results = results;
  }
};

export const getters = {
  getResults (state) {
    return state.results;
  }
};
